import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';
import { ncFilePerformanceConfig } from '@v2/pages/productionOrder/navigation/config';

const ProductionOrderDetailsNCFilePerformanceStack = createStackNavigator();

const ProductionOrderDetailsNCFilePerformanceNavigator = () => {
  return (
    <ProductionOrderDetailsNCFilePerformanceStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {ncFilePerformanceConfig.map(({ Component, name }) => (
        <ProductionOrderDetailsNCFilePerformanceStack.Screen key={name} name={name} component={Component} />
      ))}
    </ProductionOrderDetailsNCFilePerformanceStack.Navigator>
  );
};

export { ProductionOrderDetailsNCFilePerformanceNavigator };
